import Layout from '@/layout'

const contentManage = {
    path: '/patient/content',
    component: Layout,
    children: [
        {
            path: 'contentList',
            component: () => import('@/views/patient/content/contentList')
        },
        {
            path: 'addSemiOriginal',
            component: () => import('@/views/patient/content/addSemiOriginal'),
            meta: { activeMenu: '/patient/content/contentList' }
        },
        {
            path: 'addOriginal',
            component: () => import('@/views/patient/content/addOriginal'),
            meta: { activeMenu: '/patient/content/contentList' }
        },
        {
            path: 'editSemiOriginal',
            component: () => import('@/views/patient/content/editSemiOriginal'),
            meta: { activeMenu: '/patient/content/contentList' }
        },
        {
            path: 'editOriginal',
            component: () => import('@/views/patient/content/editOriginal'),
            meta: { activeMenu: '/patient/content/contentList' }
        },
        {
            path: 'bannerList',
            component: () => import('@/views/patient/content/bannerList'),
            meta: { activeMenu: '/patient/content/bannerList' }
        },
        {
            path: 'addBanner',
            name: 'patientAddBanner',
            component: () => import('@/views/patient/content/bannerAdd'),
            meta: { activeMenu: '/patient/content/bannerList' }
        },
        {
            path: 'editorBanner',
            name: 'patientEditorBanner',
            component: () => import('@/views/patient/content/bannerEditor'),
            meta: { activeMenu: '/patient/content/bannerList' }
        }
    ]
}

export default contentManage
